import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addPatientDocuments } from '../../Store/patientKyc';

const FileUploadField = ({ field, value, setFieldValue, error, touched }) => {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState(null);
  const [fileName, setFileName] = useState('');
  const [fileType, setFileType] = useState('');

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setFileName(file.name);
    setFileType(file.type);

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result;
      setFieldValue(field.name, base64String);
      
      // Create preview based on file type
      if (file.type.startsWith('image/')) {
        setPreview(base64String);
      } else if (file.type === 'application/pdf') {
        setPreview('pdf');
      }

      // Dispatch file data to Redux
      dispatch(addPatientDocuments({
        [field.name]: {
          fileName: file.name,
          fileType: file.type,
          fileData: base64String,
          timestamp: new Date().toISOString()
        }
      }));
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveFile = () => {
    setFieldValue(field.name, '');
    setPreview(null);
    setFileName('');
    setFileType('');

    // Dispatch removal to Redux
    dispatch(addPatientDocuments({
      [field.name]: null
    }));
  };

  return (
    <div className="file-upload-field">
      <div className="file-upload-container">
        <input
          type="file"
          id={field.name}
          accept="image/jpeg,image/png,image/jpg,application/pdf"
          onChange={handleFileChange}
          className="file-input"
        />
        <label htmlFor={field.name} className="file-upload-label">
          {fileName ? fileName : `Choose ${field.label} file`}
        </label>
        {value && (
          <button
            type="button"
            className="remove-file-btn"
            onClick={handleRemoveFile}
          >
            Remove
          </button>
        )}
      </div>
      
      {preview && (
        <div className="file-preview">
          <h4>Preview:</h4>
          {preview === 'pdf' ? (
            <div className="pdf-preview">
              <div className="pdf-icon">PDF</div>
              <a 
                href={value} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="view-pdf-link"
              >
                View PDF
              </a>
            </div>
          ) : (
            <div className="image-preview">
              <img src={preview} alt={`${field.label} preview`} />
            </div>
          )}
        </div>
      )}
      
      {touched && error && (
        <div className="error-message">{error}</div>
      )}
    </div>
  );
};

export default FileUploadField;
  